import { combineReducers } from 'redux';
import initialFormState from './initialFormState';
import languageState from './languageState';

const formStateReducer = (state = initialFormState, action) => {
  switch (action.type) {
    case 'UPDATE_STATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const languageReducer = (state = languageState) => {
  return state;
};

export default combineReducers({
  formState: formStateReducer,
  languageReducer,
});
